import { useEffect } from 'react';
import './App.css';
import './ThankYou.css';

function ThankYou() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="page">
      <div className="noise" />

      <nav className="nav">
        <span className="nav-logo">@AskSophiaLee</span>
      </nav>

      <section className="ty-hero">
        <div className="ty-glow" />
        <span className="ty-badge">✓ YOU'RE IN</span>
        <h1 className="ty-title">Check your inbox.</h1>
        <p className="ty-sub">
          We just emailed your framework. Look for a message from{' '}
          <strong>hello@smartincomeig.com</strong>.
          <br /><br />
          Don't see it in 2 minutes? Check spam — and add us to your contacts so the next email lands.
        </p>
        <p className="ty-note">
          Trouble? <a href="mailto:hello@smartincomeig.com">hello@smartincomeig.com</a>
        </p>
      </section>
    </div>
  );
}

export default ThankYou;